// Small DOM confetti burst; no dependencies.
export function burstConfetti(x = window.innerWidth / 2, y = window.innerHeight / 2, count = 60) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  const colors = ['#7c5cbf', '#a78bda', '#4a3580', '#febc2e', '#28c840', '#ff5f57']
  for (let i = 0; i < count; i++) {
    const el = document.createElement('span')
    const size = 6 + Math.random() * 6
    Object.assign(el.style, {
      position: 'fixed', left: `${x}px`, top: `${y}px`, width: `${size}px`, height: `${size * 0.6}px`,
      background: colors[i % colors.length], borderRadius: '2px', zIndex: 3000, pointerEvents: 'none',
    })
    document.body.appendChild(el)
    const angle = Math.random() * Math.PI * 2
    const dist = 80 + Math.random() * 220
    const anim = el.animate(
      [
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: `translate(${Math.cos(angle) * dist}px, ${Math.sin(angle) * dist - 60}px) rotate(${Math.random() * 720}deg)`, opacity: 1, offset: 0.55 },
        { transform: `translate(${Math.cos(angle) * dist * 1.1}px, ${Math.sin(angle) * dist + 260}px) rotate(${Math.random() * 1080}deg)`, opacity: 0 },
      ],
      { duration: 1400 + Math.random() * 600, easing: 'cubic-bezier(.2,.7,.3,1)' }
    )
    anim.onfinish = () => el.remove()
  }
}
